<script lang="ts">
  import { onMount, onDestroy } from "svelte";
  import { pods, loading, error } from "../stores/pods";
  import { api } from "../lib/api";
  import PodCard from "../components/PodCard.svelte";

  let interval: ReturnType<typeof setInterval>;

  onMount(() => {
    loadPods();
    interval = setInterval(loadPods, 10_000);
  });

  onDestroy(() => clearInterval(interval));

  async function loadPods() {
    loading.set(true);
    error.set(null);
    try {
      const list = await api.listPods();
      pods.set(list);
    } catch (err: any) {
      error.set(err.message);
    } finally {
      loading.set(false);
    }
  }
</script>

<div class="dashboard">
  <div class="dashboard-header">
    <h2>Workloads</h2>
    <button class="btn-ghost" onclick={loadPods}>Refresh</button>
  </div>

  {#if $error}
    <div class="error-banner">{$error}</div>
  {/if}

  {#if $pods.length === 0 && !$loading}
    <div class="empty">
      <p>No managed workloads found.</p>
      <p class="hint">Ensure pods have the <code>antares.io/managed=true</code> label.</p>
    </div>
  {:else}
    <div class="pod-grid">
      {#each $pods as pod (pod.namespace + "/" + pod.name)}
        <PodCard {pod} />
      {/each}
    </div>
  {/if}
</div>

<style>
  .dashboard-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.5rem;
  }

  h2 {
    font-size: 1.25rem;
    font-weight: 600;
  }

  .btn-ghost {
    background: none;
    border: 1px solid var(--border);
    color: var(--text-muted);
    padding: 0.25rem 0.75rem;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.8rem;
  }

  .btn-ghost:hover {
    color: var(--text);
    border-color: var(--text-muted);
  }

  .error-banner {
    background: rgba(248, 113, 113, 0.1);
    border: 1px solid var(--danger);
    color: var(--danger);
    padding: 0.75rem 1rem;
    border-radius: 4px;
    margin-bottom: 1rem;
    font-size: 0.85rem;
  }

  .empty {
    text-align: center;
    padding: 3rem;
    color: var(--text-muted);
  }

  .empty .hint {
    margin-top: 0.5rem;
    font-size: 0.85rem;
  }

  .empty code {
    font-family: var(--font-mono);
    font-size: 0.8rem;
    color: var(--accent);
  }

  .pod-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
    gap: 1rem;
  }
</style>
